import { createRoot } from 'react-dom/client';
import App from './App';

const el = document.getElementById('dashboard-app');
if (el) {
  createRoot(el).render(<App />);
}
